import { render, staticRenderFns } from "./OtherLanguagesStep.vue?vue&type=template&id=480a5bb0&"
import script from "./OtherLanguagesStep.vue?vue&type=script&lang=js&"
export * from "./OtherLanguagesStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports